(() => {
  if (window.platenzaakAnalytics || window.Shopify?.designMode) return;
  const currency = document.currentScript?.dataset.platenzaakAnalyticsCurrency || window.currentCurrency;
  let destinationsReady = false;
  const pending = [];
  const push = payload => {
    window.dataLayer ||= [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  };
  const readProduct = root => {
    try {
      const source = root?.matches?.('[data-platenzaak-analytics-product]') ? root : root?.querySelector('[data-platenzaak-analytics-product]');
      return JSON.parse(source?.textContent || 'null');
    } catch {
      return null;
    }
  };
  const emit = (event, items) => {
    if (!items.length || !currency) return;
    const payload = {
      event,
      ecommerce: {
        currency,
        value: Math.round(items.reduce((total, item) => total + item.price * item.quantity, 0) * 100) / 100,
        items,
      },
      page_location: window.location.href,
      page_title: document.title,
      page_referrer: document.referrer,
      fired_from: 'platenzaak_theme',
    };
    if (destinationsReady) push(payload);
    else pending.push(payload);
  };
  window.platenzaakAnalytics = {
    added(response, host, formData) {
      // Analytics must never change a successful purchase into an error.
      try {
        if (!response || response.status >= 400) return;
        const metadata = readProduct(host);
        const requestedId = String(formData.get('id') || '');
        const requestedQuantity = formData.getAll('quantity').map(Number).filter(value => Number.isInteger(value) && value > 0).pop() || 1;
        const lines = Array.isArray(response.items) ? response.items : [response];
        const items = lines.filter(line => line.variant_id && line.product_id && Number.isInteger(line.quantity) && line.quantity > 0).map(line => {
          const facts = metadata?.product_id === String(line.product_id) ? metadata : {};
          return {
            ...facts,
            item_id: String(line.variant_id),
            item_name: line.product_title || facts.item_name || line.title,
            item_brand: facts.item_brand || line.vendor || '',
            item_category: facts.item_category || line.product_type || '',
            item_variant: line.variant_title || '',
            price: Number(line.final_price ?? line.price) / 100,
            quantity: String(line.variant_id) === requestedId ? requestedQuantity : line.quantity,
          };
        }).filter(item => Number.isFinite(item.price) && item.price >= 0 && item.item_name);
        emit('product_added_to_cart', items);
      } catch { /* Keep tracking failure isolated from the cart. */ }
    },
  };
  const page = document.querySelector('[data-platenzaak-analytics-page]');
  const product = readProduct(page);
  if (product?.item_id && Number.isFinite(product.price)) emit('product_viewed', [product]);

  // Canopy's additional destinations. Let GTM initialize its own pixels first,
  // then initialize only missing IDs before releasing the ecommerce events.
  const ready = () => {
    if (destinationsReady) return;
    destinationsReady = true;
    try {
      if (!window.fbq) {
        const fbq = window.fbq = function () {
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        window._fbq ||= fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      const metaId = '567318173708059';
      const metaInitialized = window.fbq.getState?.().pixels?.some(pixel => String(pixel.id) === metaId)
        || window.fbq.queue?.some(command => command[0] === 'init' && String(command[1]) === metaId);
      if (!metaInitialized) {
        window.fbq('init', metaId);
        // A global PageView would also resend GTM's existing Meta pixel.
        window.fbq('trackSingle', metaId, 'PageView');
      }
    } catch { /* A blocked advertising provider must not block ecommerce. */ }
    try {
      const tiktokId = 'C6GF8JGB3BVPD5SJQS90';
      const ttq = window.ttq ||= [];
      if (!ttq._i?.[tiktokId]) {
        if (typeof ttq.load !== 'function') {
          // Original Canopy/TikTok queue bootstrap, without a global page call.
          window.TiktokAnalyticsObject = 'ttq';
          ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
          ttq.setAndDefer = (target, method) => { target[method] = (...args) => target.push([method, ...args]); };
          ttq.methods.forEach(method => ttq.setAndDefer(ttq, method));
          ttq.instance = id => {
            const instance = ttq._i[id];
            ttq.methods.forEach(method => ttq.setAndDefer(instance, method));
            return instance;
          };
          ttq.load = id => {
            ttq._i ||= {};
            ttq._i[id] = [];
            ttq._i[id]._u = 'https://analytics.tiktok.com/i18n/pixel/events.js';
            ttq._t ||= {};
            ttq._t[id] = Date.now();
            ttq._o ||= {};
            ttq._o[id] = {};
            const script = document.createElement('script');
            script.async = true;
            script.src = `${ttq._i[id]._u}?sdkid=${id}&lib=ttq`;
            document.head.appendChild(script);
          };
        }
        ttq.load(tiktokId);
        ttq.instance(tiktokId).page();
      }
    } catch { /* Keep vendor failures isolated. */ }
    pending.splice(0).forEach(payload => { try { push(payload); } catch { /* Isolate GTM errors. */ } });
  };
  // Do not race a slow GTM bootstrap: its initial global PageView must finish
  // before the additional Canopy pixel receives its targeted PageView.
  window.dataLayer ||= [];
  window.dataLayer.push({ event: 'platenzaak_destinations_ready', eventCallback: ready, eventTimeout: 2000 });
})();
